import React from 'react';
import { TypeFiledSearchMor } from './types/home.type';
import { PiSealCheckBold } from 'react-icons/pi';
import Link from 'next/link';

export default function FildeSearchMorCom({
    id,
    name,
    type,
    slug,
    prefix,
}: TypeFiledSearchMor) {
    return (
        <Link
            href={`/doctors/${type}/${slug}`}
            key={id}
            className="flex_between items-center py-1 border-b-[1px] border-gray-300 hover:text-blue-600 transition-colors hover:bg-gray-200 cursor-pointer"
        >
            <h3 className="text-blue-600 text-xs my-[5px] flex justify-start gap-3 px-2 items-center">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 128 128" 
                    className='w-[18px]'  
                >
                    <path 
                        className='fill-blue'
                        d="M103.214 61.393c-7.563 0-13.719 6.151-13.719 13.718 0 6.607 4.798 12.161 10.952 13.435v10.525c0 12.381-11.214 22.45-23.589 22.45s-23.589-10.069-23.589-22.45V79.957c6.154-.189 11.332-1.321 17.684-5.632C79.68 68.41 90.802 55.022 91.62 24.832c.189-6.812-2.508-12.649-7.807-16.031-2.925-1.841-5.929-2.674-7.98-3.021V4.678c0-2.423-1.665-4.484-4.102-4.484-2.437 0-4.102 2.061-4.102 4.484v12.051c0 2.438 1.665 4.499 4.102 4.499 2.437 0 4.102-2.061 4.102-4.499v-4.547c2.051.362 3.384 1.038 4.799 1.935 1.997 1.259 5.403 4.311 5.23 10.541-.739 27.515-9.909 39.378-17.41 44.459-6.997 4.751-14.043 4.688-16.009 4.562-.189-.016-.315-.016-.363-.016l-.307.016c-1.981.126-8.983.189-15.964-4.562-7.5-5.081-16.528-16.944-17.283-44.459-.157-6.23 2.776-9.282 4.758-10.541 1.95-1.243 3.32-1.825 5.371-2.077v4.688c0 2.438 1.665 4.499 4.102 4.499s4.102-2.061 4.102-4.499V4.678c0-2.423-1.665-4.484-4.102-4.484s-4.102 2.061-4.102 4.484v1.007c-4.102.283-5.561 1.07-8.784 3.115-5.283 3.367-8.307 9.219-8.134 16.031.833 30.19 10.708 43.578 19.435 49.493 6.305 4.295 11.842 5.428 15.944 5.632v19.115c0 15.842 12.883 28.743 28.717 28.743 15.85 0 28.717-12.9 28.717-28.743V88.358c8.205-1.557 11.275-6.922 11.275-13.246-.001-7.568-5.048-13.719-12.611-13.719zm0 21.144c-4.088 0-7.422-3.335-7.422-7.426s3.333-7.426 7.422-7.426c4.104 0 7.422 3.335 7.422 7.426s-3.318 7.426-7.422 7.426z"
                    />
                </svg>
                {prefix} {name}
            </h3>
        </Link>
    );
}
